<template>
	<div>
		<div class="fifle-box" style="border: none;">
			<van-field v-model="stuName" placeholder="请输入学生姓名或学工号" />
			<van-button type="default" hairline @click="searchStu">搜索</van-button>
		</div>
		<van-cell is-link v-for="(it, index) in stuList" :key="index" @click="navTo(it)">
			<div class="list-box">
				<p v-text="it.name"></p>
				<p v-text="it.studentOrTeacherCode"></p>
				<p v-text="it.deptName"></p>
			</div>
		</van-cell>
		<div class="no-data" v-if="stuList.length == 0">
			<img src="../../assets/no_data.svg" alt="">
			<p class="color-gray">当前没有数据</p>
		</div>
		<bottom-tab></bottom-tab>
	</div>
</template>

<script>
	import Vue from 'vue'
	import api from '../../http/api.js'
	import {
		Field,
		Cell,
		Button,
		Toast
	} from 'vant';

	Vue.use(Button);
	Vue.use(Field);
	Vue.use(Cell)
	Vue.use(Toast)

	export default {
		data() {
			return {
				stuName: '',
				deptId: window.localStorage.getItem('scDeptId'),
				stuList: [],
				isVirus: 0,
				isArchives: 0
			}
		},
		methods: {
			pageInit() {
				if (this.$route.query.isVirus) {
					// 从疫情上报推送界面路由过来的
					// console.log(this.$route.query.isVirus);
					this.isVirus = 1
				}
				if (this.$route.query.isArchives) {
					this.isArchives = 1
				}
			},
			searchStu() {
				this.stuList = []
				let data = JSON.stringify({
					deptId: this.deptId,
					pageNum: 1,
					pageSize: 10000,
					roleIds: [5, 6],
					name: this.stuName
				})
				api.findUserPage(data).then(res => {
					if (res.data.code == 200) {
						if (res.data.data.content.length > 0) {
							for (let i = 0; i < res.data.data.content.length; i++) {
								this.stuList.push(res.data.data.content[i])
							}
						} else {
							Toast('未查找到结果,请检查输入内容')
						}

					} else {
						Toast('获取失败：' + res.data.msg)
					}
				})
			},
			navTo(it) {
				if (this.isVirus == 1) {
					window.localStorage.setItem('selectStuName', it.name)
					window.localStorage.setItem('selectStuId', it.id)
					let depts = [];
					let roles = [];
					for(let i = 0; i < it.depts.length; i++){
						depts.push(it.depts[i].id)
					}
					for(let i = 0; i < it.roles.length; i++){
						roles.push(it.roles[i].id)
					}
					window.localStorage.setItem('selectStuDepts', depts)
					window.localStorage.setItem('selectStuRoles', roles)
					this.$router.go(-1)
				} else if (this.isArchives == 1) {
					window.localStorage.setItem('selectStuId', it.id)
					this.$router.push('/tempArchives')
				} else {
					this.$router.push({
						path: '/peopleTemp',
						query: {
							id: it.id
						}
					})
				}

			}
		},
		mounted() {
			this.pageInit()
		}
	}
</script>

<style scoped>
	.fifle-box {
		display: flex;
	}

	.fifle-box div:nth-child(1) {
		width: 80%;
	}

	.list-box {
		display: flex;
		justify-content: space-between;
	}

	.list-box p:nth-child(3) {
		width: 40%;
		text-align: right;
	}

	p {
		margin: 0;
		line-height: 40px;
	}

	.van-cell__right-icon {
		line-height: 40px;
	}

	.no-data {
		padding-top: 1rem;
		text-align: center;
	}
</style>
